import { apiInstance } from "../config/apiInstance";

export const getFileGeneric = async(url:string): Promise<any> => {
    const response = await apiInstance.get(`${url}`, { 
        responseType: 'blob',
        timeout: 0,
        headers:{
          'X-Timezone-Id': 'America/Bogota', 
          'Accept-Language': 'es-CO',
        }
      });
    
    return response;
}